import { SyntheticEvent } from 'react';

import { Stack, Tab, Tabs } from '@mui/material';

import { productTabs } from '../data/product-tabs';

type CustomTabsProps = {
  value: number;
  handleChange: (_event: SyntheticEvent, newValue: number) => void;
};

export const CustomTabs = ({ value, handleChange }: CustomTabsProps) => {
  return (
    <Stack borderBottom={1} borderColor="#828D98" mb={3}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="resources-tab"
        variant="fullWidth"
        TabIndicatorProps={{
          sx: {
            fontSize: 700,
            height: 5,
            width: '100px !important',
            marginLeft: '6.5%',
          },
        }}
      >
        {productTabs.map((panel, key) => (
          <Tab
            key={key}
            label={panel.label}
            id={`tab-${key}`}
            aria-controls={`tabpanel-${key}`}
          />
        ))}
      </Tabs>
    </Stack>
  );
};
